import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule, MatCardModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatPaginatorModule, MatInputModule, MatSelectModule, MatMenuModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiTableComponent } from './api-table.component';
import { ApiTableService } from './api-table.service';
import { ExtendPipesModule } from '../../common';
var ExtendzApiTableModule = /** @class */ (function () {
    function ExtendzApiTableModule() {
    }
    ExtendzApiTableModule = tslib_1.__decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                ReactiveFormsModule,
                FlexLayoutModule,
                // Extend
                ExtendPipesModule,
                // Mat
                MatButtonModule,
                MatMenuModule,
                MatCheckboxModule,
                MatTableModule,
                MatCardModule,
                MatIconModule,
                MatTableModule,
                MatPaginatorModule,
                MatInputModule,
                MatSelectModule
            ],
            declarations: [ApiTableComponent],
            exports: [ApiTableComponent],
            providers: [ApiTableService]
        })
    ], ExtendzApiTableModule);
    return ExtendzApiTableModule;
}());
export { ExtendzApiTableModule };
//# sourceMappingURL=extendz-api-table.module.js.map